import React, { ComponentProps, FC } from 'react';

import styled, { css } from 'styled-components';

import Picture from 'components/picture';

import { FrameAnimationFrame } from './use-frame-animation-controller';

const InvisiblePicture: FC<ComponentProps<typeof Picture> & { invisible?: boolean }> = props => (
  <Picture {...props} draggable={false} />
);

const FrameImage = styled(InvisiblePicture)`
  position: absolute;
  left: 0;
  right: 0;
  height: 100%;

  ${props =>
    props.invisible &&
    css`
      opacity: 0;
    `}
`;

/**
 * Used to display animation frame images.
 *
 * Must be used alongside `useFrameAnimationController`.
 *
 * See Storybook for more information.
 *
 * Since images must be positioned absolutely, styling the
 * height of this component is a requirement.
 */
export interface FrameAnimationProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Currently displayed animation frame */
  currentFrame: number;
  frames: FrameAnimationFrame[];
  /** customize props on Picture component */
  pictureProps?: ComponentProps<typeof Picture>;
}

export const FrameAnimation: FC<FrameAnimationProps> = ({
  pictureProps,
  currentFrame,
  frames,
  style,
  ...props
}) => {
  return (
    <div style={{ height: 500, ...style, position: 'relative' }} {...props}>
      {frames.map((frame, index) => {
        const isVisible = index === currentFrame;

        return (
          <FrameImage
            image={frame}
            alt="alt"
            key={index}
            objectFitContain
            lqOff={true}
            invisible={!isVisible}
            {...pictureProps}
          />
        );
      })}
    </div>
  );
};
